/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

import { pxToRem } from '@/Client/Styles/pxToRem';
import { CameraIconOutline, CameraIconSolid, NotesIconOutline, NotesIconSolid, TaskIconOutline, TaskIconSolid } from '../../../Icons';
import { COLORS2, TYPOGRAPHY2 } from '../../../Styles';

const IconComponents = {
  camera: { solid: CameraIconSolid, outline: CameraIconOutline },
  task: { solid: TaskIconSolid, outline: TaskIconOutline },
  notes: { solid: NotesIconSolid, outline: NotesIconOutline },
};
export type ScanNavigatorIconType = keyof typeof IconComponents;

const SCAN_NAVIGATOR_ICON_ITEM_STYLE = css`
  label: SCAN_NAVIGATOR_ICON_ITEM_STYLE;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 60px;
  background-color: ${COLORS2.alwaysDark.charcoal};
  border: 1px solid ${COLORS2.alwaysDark.darkerGray};
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  &:hover {
    background-color: ${COLORS2.alwaysDark.black};
  }
`;

const SCAN_NAVIGATOR_ICON_ITEM_SELECTED_STYLE = css`
  label: SCAN_NAVIGATOR_ICON_ITEM_SELECTED_STYLE;
  background-color: ${COLORS2.alwaysDark.black};
  border-color: ${COLORS2.alwaysDark.yellow};
`;

const SCAN_NAVIGATOR_ICON_STYLE = css`
  label: SCAN_NAVIGATOR_ICON_STYLE;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${COLORS2.alwaysDark.white};
  font-size: ${pxToRem(24)};
`;

const SCAN_NAVIGATOR_COUNT_STYLE = css`
  label: SCAN_NAVIGATOR_COUNT_STYLE;
  color: ${COLORS2.alwaysDark.white};
  ${TYPOGRAPHY2.xSmall};
  margin-top: 2px;
`;

export const ScanNavigatorIconItem = (
  { icon, selected, count, onClick }: { icon: ScanNavigatorIconType; selected: boolean; count: number; onClick?: () => void },
) => {
  const Icon = IconComponents[icon][selected ? 'solid' : 'outline'];
  return (
    <div css={[SCAN_NAVIGATOR_ICON_ITEM_STYLE, selected && SCAN_NAVIGATOR_ICON_ITEM_SELECTED_STYLE]} onClick={onClick}>
      <div css={SCAN_NAVIGATOR_ICON_STYLE}>
        <Icon />
      </div>
      <div css={SCAN_NAVIGATOR_COUNT_STYLE}>{count}</div>
    </div>
  );
};
